import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import { Paper } from "@material-ui/core";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../hooks/useDataFormatterHook";

export default function Leagues(props) {
  //const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "75%",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [Leagues, setLeagues] = React.useState([]);
  const { values: sports } = useDataFormatterHook({
    value: "idSport",
    text: "sportName",
    path: "/Player/GetSports",
  });
  const [selectedLeague, setSelectedLeague] = React.useState([1]);
  useEffect(() => {
    // Change for server api address
    GetLeagues();
  }, []);

  const GetLeagues = () => {
    const url = process.env.REACT_APP_API2_URL + "/League/League_GetAllLeagues";
    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    }).then((response) => {
      setLeagues(response.data);
    });
  };

  /* se quito el ,[] que se puede para no hacer tantos renders*/
  const options = {
    page: 1, // which page you want to show as default
    sizePerPageList: [
      {
        text: "15",
        value: 15,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ], // you can change the dropdown list for size per page
    sizePerPage: 16, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 3, // the pagination bar size.
    prePage: "Prev", // Previous page button text
    nextPage: "Next", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: true, // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
    handleConfirmDeleteRow: customConfirm,
    //onRowClick: selectedValues,
    afterInsertRow: onAfterInsertRow, // A hook for after insert rows
  };

  function selectedValues(row) {
    // setRedirect(row);
  }
  const cellEditProp = {
    mode: "click",
    blurToSave: true,
    afterSaveCell: onAfterSaveCell, // a hook for after saving cell
  };

  function onAfterInsertRow(row) {
    let RequestDTO = {
      IdSport: row.idSport,
      IdLeagueRegion: 1,
      Description: row.description,
      ShortDescription: row.shortDescription,
      LeagueOrder: row.leagueOrder,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/League/League_Insert",
      //url: 'https://localhost:44337/api/League/League_Insert',
      data: RequestDTO,
    }).then((response) => {
      if (response.data === "0") {
        alert("Data Successfully Inserted");
      }
    });
    GetLeagues();
  }
  function onAfterSaveCell(row) {
    let RequestDTO = {
      IdSport: row.idSport,
      IdLeagueRegion: 1,
      Description: row.description,
      ShortDescription: row.shortDescription,
      LeagueOrder: row.leagueOrder,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      //url: 'http://192.168.3.99:4587/api/League/League_Update?idLeague=' +row.IdLeague,
      url:
        process.env.REACT_APP_API2_URL +
        "/League/League_Update?idLeague=" +
        row.idLeague,
      data: RequestDTO,
    }).then((response) => {
      if (response.data === "0") {
        alert("Data Successfully Updated");
      }
    });
    GetLeagues();
  }

  function onAfterDeleteRow(rowKeys) {
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/League/League_Delete?idLeague=" +
        rowKeys +
        "&idUser=" +
        userInfo.userId,
      //url: 'https://localhost:44337/api/League/League_Delete?idLeague=' +rowKeys +'&idUser=' + userInfo.userId,
    }).then((response) => { });
  }

  function customConfirm(next, dropRowKeys) {
    const dropRowKeysStr = dropRowKeys.join(",");
    if (
      window.confirm(
        `(It's a custom confirm)Are you sure you want to delete ${dropRowKeysStr}?`
      )
    ) {
      // If the confirmation is true, call the function that
      // continues the deletion of the record.
      next();
    }
  }

  /*Select Functions*/

  const handleChange = (event) => {
    props.setLeagueOnMem(event.target.value);
    setSelectedLeague(event.target.value);
  };

  const selectRowProp = {
    mode: "checkbox",
  };
  /*End Select Functions*/

  if (props.showDataTable) {
    return (
      <div id="main-div">
        <Paper className={classes.root}>
          <h2>Leagues</h2>
          <BootstrapTable
            data={Leagues}
            cellEdit={cellEditProp}
            options={options}
            selectRow={selectRowProp}
            pagination={true}
            insertRow={true}
            version="4"
            deleteRow={true}
            hover
          >
            <TableHeaderColumn
              visible="none"
              isKey={true}
              hidden
              hiddenOnInsert
              autoValue={true}
              dataField="idLeague"
            >
              ID
            </TableHeaderColumn>
            <TableHeaderColumn
              editable={{
                type: "select",
                readOnly: true,
                options: { values: sports },
              }}
              dataField="idSport"
            >
              Id Sport
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="description"
              filter={{ type: "TextFilter" }}
            >
              Description
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="shortDescription"
              filter={{ type: "TextFilter" }}
            >
              Short Description
            </TableHeaderColumn>
            <TableHeaderColumn dataField="leagueOrder">
              League Order
            </TableHeaderColumn>
          </BootstrapTable>
        </Paper>
      </div>
    );
  } else {
    return (
      <React.Fragment>
        <FormControl className={classes.formControl} variant="outlined">
          <InputLabel shrink id="demo-simple-select-placeholder-label-label">
            League
          </InputLabel>
          {console.log("in League RENDERING SELeCT")}
          {Leagues[0] && (
            <Select
              labelId="demo-simple-select-placeholder-label-label"
              id="demo-simple-select-placeholder-label"
              value={selectedLeague}
              onChange={handleChange}
              displayEmpty
            >
              {Leagues &&
                Leagues.map((League) => (
                  <MenuItem value={League.idLeague}>
                    {League.description}
                  </MenuItem>
                ))}
            </Select>
          )}

          {/* <FormHelperText>Select League</FormHelperText> */}
        </FormControl>
      </React.Fragment>
    );
  }
}
